var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBgGradient = function SvgBgGradient(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 680,
    viewBox: "0 0 1440 680",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1528_60230)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_1528_60230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1270.21 539.333C2112.62 367.984 2174.61 516.014 1655.78 1004.93L1245.82 1447.66L151.503 1053.73C13.7575 987.456 -636.928 862.059 -471.452 589.526C-305.976 316.993 75.8693 467.6 246.107 576.971C340.849 637.838 427.804 710.682 1270.21 539.333Z",
    fill: "url(#paint0_linear_1528_60230)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1528_60230",
    x: -618.205,
    y: 315.652,
    width: 2725.57,
    height: 1252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_1528_60230"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1528_60230",
    x1: 470.749,
    y1: 929.59,
    x2: 863.914,
    y2: -162.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FF4FC",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F48FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1528_60230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1863,
    height: 1081,
    fill: "white",
    transform: "translate(-211)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBgGradient);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI2ODAiIHZpZXdCb3g9IjAgMCAxNDQwIDY4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE1MjhfNjAyMzApIj4KPGcgb3BhY2l0eT0iMC4zIiBmaWx0ZXI9InVybCgjZmlsdGVyMF9mXzE1MjhfNjAyMzApIj4KPHBhdGggZD0iTTEyNzAuMjEgNTM5LjMzM0MyMTEyLjYyIDM2Ny45ODQgMjE3NC42MSA1MTYuMDE0IDE2NTUuNzggMTAwNC45M0wxMjQ1LjgyIDE0NDcuNjZMMTUxLjUwMyAxMDUzLjczQzEzLjc1NzUgOTg3LjQ1NiAtNjM2LjkyOCA4NjIuMDU5IC00NzEuNDUyIDU4OS41MjZDLTMwNS45NzYgMzE2Ljk5MyA3NS44NjkzIDQ2Ny42IDI0Ni4xMDcgNTc2Ljk3MUMzNDAuODQ5IDYzNy44MzggNDI3LjgwNCA3MTAuNjgyIDEyNzAuMjEgNTM5LjMzM1oiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8xNTI4XzYwMjMwKSIvPgo8L2c+CjwvZz4KPGRlZnM+CjxmaWx0ZXIgaWQ9ImZpbHRlcjBfZl8xNTI4XzYwMjMwIiB4PSItNjE4LjIwNSIgeT0iMzE1LjY1MiIgd2lkdGg9IjI3MjUuNTciIGhlaWdodD0iMTI1MiIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJzaGFwZSIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSI2MCIgcmVzdWx0PSJlZmZlY3QxX2ZvcmVncm91bmRCbHVyXzE1MjhfNjAyMzAiLz4KPC9maWx0ZXI+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8xNTI4XzYwMjMwIiB4MT0iNDcwLjc0OSIgeTE9IjkyOS41OSIgeDI9Ijg2My45MTQiIHkyPSItMTYyLjU5OCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjOEZGNEZDIiBzdG9wLW9wYWNpdHk9IjAuNTMiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjMkY0OEZGIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTUyOF82MDIzMCI+CjxyZWN0IHdpZHRoPSIxODYzIiBoZWlnaHQ9IjEwODEiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjExKSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";